import AppForm from "components/AppForm/AppForm";
import CrudPage from "components/CrudPage/CrudPage";
import { withRemoteDataAndSpinner } from "hoc/withRemoteDataAndSpinner";
import withRouter from "hoc/withRouter";
import { useLoadAll } from "hooks/useLoadAll";
import inputTypeEnum from "enums/inputTypes";
import warehouseService from "services/admin/warehousesService";
import { snack } from "components/Snack/Snack";
import { countriesService } from "services/countries.service";
import { citiesService } from "services/cities.service";

const WarehouseForm = ({
  router: {
    navigate,
    params: { id },
  },
  data: { warehouse, cities, countries },
}) => {
  const fieldsWithData = [
    {
      key: "name",
      label: "Название",
      required: true,
      inputType: inputTypeEnum.text,
    },
    {
      key: "countryID",
      label: "Страна",
      inputType: inputTypeEnum.select,
      value: "KAZ",
      options: countries ? countries.data : []
    },
    {
      key: "cityID",
      label: "Город",
      inputType: inputTypeEnum.select,
      options: cities ? cities.data : []
    },
    {
      key: "address1",
      label: "Адрес",
      inputType: inputTypeEnum.text,
    },
    {
      key: "address2",
      label: "Дом/квартира/офис",
      inputType: inputTypeEnum.text,
    },
    {
      key: "phone",
      label: "Телефон",
      inputType: inputTypeEnum.text,
    },
    {
      key: "email",
      label: "Email",
      inputType: inputTypeEnum.text,
    },
    // isLegacy
    {
      key: "isLegacy",
      label: "Принимать заказы",
      inputType: inputTypeEnum.checkbox,
      defaultValue: false,
    }
  ]

  const onSubmit = async (formValues) => {
    try {

      if (warehouse) {
        await warehouseService.put(id, formValues)
        snack("Склад обновлен успешно!");
      } else {
        await warehouseService.post(formValues)
        snack("Склад создан успешно!");
      }

      setTimeout(() => {
        navigate(-1);
      }, 500);
    } catch (ex) {
      console.error(ex)
    }
  };

  return (
    <CrudPage title={warehouse ? 'Редактирование точки продаж' : 'Создание точки продаж'}>
      <AppForm onSubmit={onSubmit} data={warehouse} fields={fieldsWithData}></AppForm>
    </CrudPage>
  );
};
export default withRouter(
  withRemoteDataAndSpinner(WarehouseForm, (router) => {
    let requests = {
      countries: () => countriesService.getAll(),
      cities: () => citiesService.getAll("KAZ")
    }
    if (router.params.id) {
      requests['warehouse'] = () => warehouseService.get(router.params.id)
    }
    return useLoadAll(requests);
  })
);
